"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA4EventName = void 0;
var GA4EventName;
(function (GA4EventName) {
    GA4EventName["AddPaybackAccount"] = "add_payback_account";
    GA4EventName["AddToCart"] = "add_to_cart";
    GA4EventName["RemoveFromCart"] = "remove_from_cart";
    GA4EventName["DeleteCartProduct"] = "delete_cart_product";
    GA4EventName["IncreaseCount"] = "increase_count";
    GA4EventName["DecreaseCount"] = "decrease_count";
    GA4EventName["AddToWishlist"] = "add_to_wishlist";
    GA4EventName["RemoveFromWishlist"] = "remove_from_wishlist";
    GA4EventName["ViewItemList"] = "view_item_list";
    GA4EventName["ViewItem"] = "view_item";
    GA4EventName["ViewPromotion"] = "view_promotion";
    GA4EventName["ViewCart"] = "view_cart";
    GA4EventName["ViewProductSelectorBlock"] = "view_product_productselectorblock";
    GA4EventName["BeginCheckout"] = "begin_checkout";
    GA4EventName["CheckoutOverview"] = "overview_checkout";
    GA4EventName["ClickButton"] = "click_button";
    GA4EventName["ClickTextLink"] = "click_textlink";
    GA4EventName["ClickEcomCta"] = "click_eCom_cta";
    GA4EventName["ClickExpressPayment"] = "click_express_payment";
    GA4EventName["ClickTab"] = "click_tab";
    GA4EventName["ClickRating"] = "click_rating";
    GA4EventName["ClickProductSelectorBlock"] = "click_product_productselectorblock";
    GA4EventName["ClickEditOrderDetails"] = "click_edit_order_details";
    GA4EventName["SelectItem"] = "select_item";
    GA4EventName["SelectPackagingMethod"] = "select_packaging_method";
    GA4EventName["SelectPaymentMethod"] = "select_payment_method";
    GA4EventName["SelectPromotion"] = "select_promotion";
    GA4EventName["SelectProductVariant"] = "select_product_variant";
    GA4EventName["selectShippingMethod"] = "select_shipping_method";
    GA4EventName["SelectTicketOptions"] = "select_ticket_options";
    GA4EventName["SelectValueVoucherAmount"] = "select_valuevoucher_amount";
    GA4EventName["CloseAccordion"] = "close_accordion";
    GA4EventName["OpenMap"] = "open_map";
    GA4EventName["CloseMap"] = "close_map";
    GA4EventName["OpenAccordion"] = "open_accordion";
    GA4EventName["ShowNotification"] = "show_notification";
    GA4EventName["ShowSearchPopup"] = "show_search_popup";
    GA4EventName["ShowSearchResult"] = "show_search_result";
    GA4EventName["ShowPopup"] = "show_popup";
    GA4EventName["SlidePromotionItem"] = "slide_promotion_item";
    GA4EventName["SubmitSearch"] = "search";
    GA4EventName["Share"] = "share";
    GA4EventName["SwitchPicture"] = "switch_picture";
    GA4EventName["SetFilter"] = "set_filter";
    GA4EventName["SelectCheckBox"] = "select_checkbox";
    GA4EventName["SetSorting"] = "set_sorting";
    GA4EventName["ResetFilter"] = "reset_filter";
    GA4EventName["ExpandFilter"] = "expand_filter";
    GA4EventName["DeselectFilter"] = "deselect_filter";
    GA4EventName["ClickProductPicture"] = "click_product_picture";
    GA4EventName["DeleteVoucher"] = "delete_voucher";
    GA4EventName["ClickNavigationItem"] = "click_navigation_item";
    GA4EventName["AddVoucher"] = "add_voucher";
    GA4EventName["SelectSpvOptions"] = "select_spv_options";
    GA4EventName["ShowTextLink"] = "show_textlink";
    GA4EventName["ClickPagination"] = "click_pagination";
    GA4EventName["AddDiscount"] = "add_discount";
    GA4EventName["OpenNavigationItem"] = "open_navigation_item";
    GA4EventName["CloseNavigationItem"] = "close_navigation_item";
    GA4EventName["SlideNavigationItem"] = "slide_navigation_item";
    GA4EventName["ExpandDropdown"] = "expand_dropdown";
    GA4EventName["SubscribeNewsletter"] = "subscribe_newsletter";
    GA4EventName["SubscribeNewsletterDoi"] = "subscribe_newsletter_doi";
    GA4EventName["ClickCTA"] = "click_cta";
    GA4EventName["ClickAddToWishlist"] = "click_add_to_wishlist";
})(GA4EventName || (exports.GA4EventName = GA4EventName = {}));
//# sourceMappingURL=GA4EventName.js.map